import React from "react";
import {AccordianSection} from "./accordian-section";

export const Skills = ({heading, contents}) => {

    const skillComponent = <SkillList contents={contents}/>
    return <AccordianSection heading={heading} component={skillComponent}/>
}
export const SkillList = ({contents}) => {
    return <ul className='skills'>
        {contents.map(el => <li>{el}</li>)}
    </ul>
}
export const SkillSectionList = ({map}) => {

    return (<div>
        {map.skills.map(el => <Skills {...el}/>)}
    </div>)

}